import { Injectable, inject } from '@angular/core';

import {
  Overlay,
  OverlayHorizontalPosition,
  OverlayPositionBuilder,
  OverlayVerticalPosition,
} from '@app-core/services/overlay';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { v4 as randomUUID } from 'uuid';

import { NotificationItem } from './notification/notification.interface';
import { NotificationPanelComponent } from './notification-panel/notification-panel.component';

@Injectable({
  providedIn: 'root',
})
export class Notification {
  private o = inject(Overlay);
  private pb = inject(OverlayPositionBuilder);

  private _notifications$: BehaviorSubject<NotificationItem[]> = new BehaviorSubject<NotificationItem[]>([]);

  constructor() {
    this.o.attach(NotificationPanelComponent, {
      position: this.pb.position({
        horizontal: OverlayHorizontalPosition.end,
        vertical: OverlayVerticalPosition.top,
      }),
      data: { notification: this },
    });
  }

  notifications$(): Observable<NotificationItem[]> {
    return this._notifications$.asObservable();
  }

  clear(): void {
    this._notifications$.next([]);
  }

  display(value: NotificationItem): void {
    this._notifications$.pipe(take(1)).subscribe((notifications: NotificationItem[]) => {
      this._notifications$.next([{ ...value, id: randomUUID() }, ...notifications]);
    });
  }

  remove(notificationID: string): void {
    this._notifications$.pipe(take(1)).subscribe((value: NotificationItem[]) => {
      const notifications = [...value];
      const index = notifications.findIndex(({ id }) => notificationID === id);

      if (index !== -1) {
        notifications.splice(index, 1);
        this._notifications$.next(notifications);
      }
    });
  }
}
